<section class="flex flex-col gap-8">
  <p class="text-center text-base">
    More than 3,000 teams build with Capawesome
  </p>
  <div class="w-full overflow-hidden">
    <div class="logo-scroll flex gap-24">
      @for (logo of logos(); track logo.src) {
        <div class="flex min-w-32 flex-shrink-0 items-center justify-center">
          @defer {
            <img
              [alt]="logo.alt"
              [class]="
                'h-12 object-contain grayscale' +
                (logo.invertColors ? ' invert' : '')
              "
              [src]="logo.src"
            />
          } @placeholder {
            <div class="h-12 w-32 animate-pulse bg-gray-200"></div>
          }
        </div>
      }
      @for (logo of logos(); track logo.src + "-duplicate") {
        <div class="flex min-w-32 flex-shrink-0 items-center justify-center">
          @defer {
            <img
              [alt]="logo.alt"
              [class]="
                'h-12 object-contain grayscale' +
                (logo.invertColors ? ' invert' : '')
              "
              [src]="logo.src"
            />
          } @placeholder {
            <div class="h-12 w-32 animate-pulse bg-gray-200"></div>
          }
        </div>
      }
    </div>
  </div>
</section>
